import _ from 'lodash';

import fbLogo from 'assets/images/social_logos/fb_logo.svg';
import twitterLogo from 'assets/images/social_logos/twitter_logo.svg';
import linkedInLogo from 'assets/images/social_logos/linkedIn_logo.svg';
import youtubeLogo from 'assets/images/social_logos/youtube_logo.svg';
import instagramLogo from 'assets/images/social_logos/instagram_logo.svg';
import weiboLogo from 'assets/images/social_logos/weibo_logo.svg';
import youkuLogo from 'assets/images/social_logos/youku_logo.svg';
import wechatLogo from 'assets/images/social_logos/wechat_logo.svg';
import kakaoLogo from 'assets/images/social_logos/kakao_logo.svg';
import naverLogo from 'assets/images/social_logos/naver_logo.svg';

export const getCompanyLocation = company => {
  const {
    billing_street,
    billing_city,
    billing_postcode,
    billing_country
  } = company;

  const billingCityName = _.get(billing_city, 'name');

  if (
    _.isNil(billing_street) ||
    _.isNil(billingCityName) ||
    _.isNil(billing_postcode) ||
    _.isNil(billing_country)
  )
    return null;

  return `${billing_street}, ${billingCityName} ${billing_postcode}, ${
    billing_country.name
  }`;
};

export const getSocialLinks = vendor => {
  const {
    facebook,
    twitter,
    linkedin,
    youtube,
    instagram,
    naver,
    weibo,
    youku,
    wechat,
    kakao
  } = vendor;

  const socialLinksData = [
    {
      logo: fbLogo,
      link: facebook,
      name: 'facebook'
    },
    {
      logo: twitterLogo,
      link: twitter,
      name: 'twitter'
    },
    {
      logo: linkedInLogo,
      link: linkedin,
      name: 'linkedin'
    },
    {
      logo: youtubeLogo,
      link: youtube,
      name: 'youtube'
    },
    {
      logo: instagramLogo,
      link: instagram,
      name: 'instagram'
    },
    {
      logo: naverLogo,
      link: naver,
      name: 'naver'
    },
    {
      logo: weiboLogo,
      link: weibo,
      name: 'weibo'
    },
    {
      logo: youkuLogo,
      link: youku,
      name: 'youku'
    },
    {
      logo: wechatLogo,
      link: wechat,
      name: 'wechat'
    },
    {
      logo: kakaoLogo,
      link: kakao,
      name: 'kakao'
    }
  ];

  const validLinks = socialLinksData.filter(item => !_.isNil(item.link));
  const shouldRender = validLinks.length > 0;

  return { shouldRender, links: validLinks };
};

export const getVendorWebsite = website => {
  if (!_.isNil(website) && !website.startsWith('http'))
    return `http://${website}`;

  return website;
};
